export default __webpack_public_path__ + "static/media/Initiate's Tunic of the Burning Disc.c296a304.jpg";